/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIntegrationAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 8V6h-1.141a3.956 3.956 0 0 0-.425-1.02l.808-.808-1.414-1.415-.808.809A3.956 3.956 0 0 0 18 3.141V2h-2v1.141a3.956 3.956 0 0 0-1.02.425l-.808-.809-1.415 1.415.809.808c-.186.316-.33.656-.425 1.02H12v2h1.141c.095.364.239.704.425 1.02l-.809.808 1.414 1.414.809-.808c.316.186.656.33 1.02.425V12h2v-1.141a3.991 3.991 0 0 0 1.02-.425l.808.808 1.414-1.414-.808-.808c.187-.316.33-.656.425-1.02H22zm-5 1a2 2 0 1 1 .001-4.001A2 2 0 0 1 17 9zm-5 9v-2h-1.141a3.956 3.956 0 0 0-.425-1.02l.808-.808-1.414-1.415-.808.809A3.956 3.956 0 0 0 8 13.141V12H6v1.141a3.956 3.956 0 0 0-1.02.425l-.808-.809-1.415 1.415.809.808c-.186.316-.33.656-.425 1.02H2v2h1.141c.095.364.239.704.425 1.02l-.809.808 1.414 1.414.809-.808c.316.186.656.33 1.02.425V22h2v-1.141a3.991 3.991 0 0 0 1.02-.425l.808.808 1.414-1.414-.808-.808c.187-.316.33-.656.425-1.02H12zm-5 1a2 2 0 1 1 .001-4.001A2 2 0 0 1 7 19zm3-16.8A10 10 0 0 0 4 6V4H2v6h6V8H5.07A8.017 8.017 0 0 1 10 4.252V2.2zM12 22h.032H12zm2.065-.21a10.002 10.002 0 0 0 5.95-3.79v2h2v-6h-6v2h2.931a8.017 8.017 0 0 1-4.88 3.735v2.055z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIntegrationAlt as IntegrationAlt };
